import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Rating } from 'components/shared';

const propTypes = {
  avatar: PropTypes.string.isRequired,
  cite: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fromThe: PropTypes.string,
};

const defaultProps = {
  fromThe: undefined,
};

const Blockquote = ({ avatar, cite, fromThe, children, ...props }) => {
  return (
    <Wrapper>
      <AvatarWrapper>
        <TestimonialAvatar src={avatar} />
        <blockquote style={{ "textAlign": "left" }} >
          {cite && (
            <Cite>
              {cite}
              {fromThe && <div>{fromThe}</div>}
            </Cite>
          )}
        </blockquote>
      </AvatarWrapper>
      <div>
        <Rating />
      </div>

    </Wrapper>
  );
};

const TestimonialAvatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 100%;
  margin-right: 20px;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
`;

const Wrapper = styled.div`
  border-top: 1px solid #eaeaea;
  position: relative;
  padding: 20px;
  background: #fff;
  text-align: center;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
  }
`;

const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

const Cite = styled.cite`
  text-align: left;
  font-size: var(--font-size-s);
  line-height: var(--font-size-xs);
  color: #031633;
  font-weight: 600;

  div {
    color: initial;
    font-weight: 400;
    font-size: var(--font-size-xs);
  }

  @media (max-width: 768px) {
    font-size: var(--font-size-xs);

    div {
      font-size: var(--font-size-xs);
    }
  }
`;

Blockquote.propTypes = propTypes;
Blockquote.defaultProps = defaultProps;
export default Blockquote;
